// Parser PDF výpisu — pošle PDF na server (/api/cashflow-parse-pdf),
// kde se parsuje přes pdf-parse (spolehlivější než client-side pdfjs-dist).

import { fetchApi } from "./api.js";

// Převede File na base64 string (bez data:... prefixu).
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || "";
      // result je "data:application/pdf;base64,XXXX" — vyřízneme prefix
      const idx = String(result).indexOf(",");
      resolve(idx >= 0 ? String(result).substring(idx + 1) : String(result));
    };
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

// Hlavní entry point — přijme File, vrátí Promise s transakcemi.
// Kvůli zpětné kompatibilitě vrací pole transakcí s přilepeným _meta (debug info).
export async function parsePdfFile(file) {
  const pdfBase64 = await fileToBase64(file);
  const res = await fetchApi("/api/cashflow-parse-pdf", {
    method: "POST",
    body: JSON.stringify({ pdfBase64, fileName: file.name }),
  });
  if (!res?.ok) {
    throw new Error(res?.error || "PDF parsing failed");
  }
  const txs = res.transactions || [];
  txs._meta = res.meta || null;
  txs._fileName = file.name;
  return txs;
}
